import { render, staticRenderFns } from "./visitlocationtradecode.vue?vue&type=template&id=9643ecae"
import script from "./visitlocationtradecode.vue?vue&type=script&lang=js"
export * from "./visitlocationtradecode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports